import React, { useContext } from 'react'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { EngagementLetterContext } from './EngagementLetter'

const LetterIntro = () => {
  const { engagementLetter, setEngagementLetter } = useContext(
    EngagementLetterContext
  )

  return (
    <Stack>
      <Typography variant="title3">Letter Introduction</Typography>
      <TextField
        value={engagementLetter.letterIntro}
        multiline
        minRows={3}
        onChange={(e) =>
          setEngagementLetter((prev) => ({
            ...prev,
            letterIntro: e.target.value,
          }))
        }
      />
    </Stack>
  )
}

export default LetterIntro